import { useState, useEffect } from "react";

import { Table } from "react-bootstrap";
import { addCommas, numberToWords } from "@persian-tools/persian-tools";

import ColorSchema from "../kits/Color";
import { CustomInput } from "../kits/Inputs/Inputs";
export default function Invoice({
  dataFactor,
  dispatch,
  ACTIONS,
  print = false,
}) {
  const [pricesData, setPricesData] = useState({
    totalPriceProducts: 0,
    totalDiscountProducts: 0,
    totalTax: 0,
    totalPriceProductsAfterDiscount: 0,
    totalTaxes: 0,
    totalPriceOrder: 0,
    totalCount: 0,
  });
  const calculateTax = (price, count, discount, tax) => {
    let totalPrice = parseInt(price) * parseInt(count);
    let taxPrice = Math.floor(
      (parseInt(totalPrice) *
        parseInt(tax != "" && tax != null && tax != undefined ? tax : 0)) /
        100
    );
    return taxPrice > 0 ? taxPrice : 0;
  };
  const calculateTotalPricePerProduct = (price, count, discount, tax) => {
    let taxPrice = calculateTax(
      price,
      count,
      discount,
      tax != "" && tax != null && tax != undefined ? tax : 0
    );
    let totalProduct = (parseInt(price) - parseInt(discount)) * parseInt(count);
    let totalPrice = parseInt(totalProduct) + parseInt(taxPrice);
    return totalPrice > 0 ? totalPrice : 0;
  };
  const calculatePrices = (array, tax) => {
    let totalPriceProductsTemp = 0;
    let totalDiscountProductsTemp = 0;
    let totalTaxTemp = 0;
    let totalPriceProductsAfterDiscountTemp = 0;
    let totalTaxesTemp = 0;
    let totalPriceOrderTemp = 0;
    let totalCountTemp = 0;
    for (let i = 0; i < array?.length; i++) {
      totalCountTemp += +array[i]?.count;
      totalDiscountProductsTemp += +array[i]?.discount * +array[i]?.count;
      totalPriceProductsTemp +=
        +array[i]?.price * +array[i]?.count > 0
          ? +array[i]?.price * +array[i]?.count
          : 0;
      totalPriceProductsAfterDiscountTemp =
        +totalPriceProductsTemp - +totalDiscountProductsTemp > 0
          ? +totalPriceProductsTemp - +totalDiscountProductsTemp
          : 0;
      totalTaxTemp = calculateTax(
        array[i].price,
        array[i].count,
        array[i].discount,
        tax
      );
      totalTaxesTemp += totalTaxTemp > 0 ? totalTaxTemp : 0;
      totalPriceOrderTemp +=
        (+array[i]?.price - +array[i]?.discount) * array[i].count +
          totalTaxTemp >
        0
          ? (+array[i]?.price - +array[i]?.discount) * array[i].count +
            totalTaxTemp
          : 0;
    }
    setPricesData({
      totalPriceProducts: totalPriceProductsTemp,
      totalDiscountProducts: totalDiscountProductsTemp,
      totalTax: totalTaxTemp,
      totalPriceProductsAfterDiscount: totalPriceProductsAfterDiscountTemp,
      totalTaxes: totalTaxesTemp,
      totalPriceOrder: totalPriceOrderTemp,
      totalCount: totalCountTemp,
    });
  };
  useEffect(() => {
    calculatePrices(dataFactor?.items ?? [], dataFactor?.tax ?? 0);
  }, [dataFactor]);
  console.log("dataaaaaaaaaaaaa", dataFactor);
  return (
    <div className="invoice">
      <div
        className="table-title p-1 text-center"
        style={{ backgroundColor: ColorSchema.secondary_light_custom }}
      >
        مشخصات کالا یا خدمات مورد معامله
      </div>{" "}
      <Table
        bordered
        responsive={print ? "" : "xl"}
        style={{
          textAlign: "center",
          borderColor: ColorSchema.black_custom,
          fontSize: 13,
          lineHeight: 1.8,
        }}
      >
        <thead>
          <tr>
            <th className="w-30p">ردیف</th>
            <th className="w-200p">شرح کالا و خدمات</th>
            <th className="w-30p">
              تعداد
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>مقدار</div>
            </th>
            <th className="w-100p">
              واحد
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>
                اندازه گیری
              </div>
            </th>
            <th className="w-100p">
              مبلغ واحد
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
            <th className="w-100p">
              مبلغ کل{" "}
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
            <th className="w-100p">
              مبلغ تخفیف{" "}
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
            <th className="w-100p">
              مبلغ کل پس از تخفیف{" "}
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
            <th className="w-100p">
              مالیات و عوارض
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
            <th className="w-100p">
              جمع مبلغ کل بعلاوه مالیات و عوارض
              <div style={{ fontSize: 11, fontWeight: "lighter" }}>(تومان)</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataFactor?.items?.map((value) => {
            console.log("valllllllllllllll", value);
            let productName = `${value?.product?.label} `;
            if (!print) {
              productName += value?.product?.properties?.map((v, i) => {
                return `${v.title} ${
                  v?.type == 2
                    ? v?.input_value?.label ?? ""
                    : v?.input_value ?? ""
                } `;
              });
            } else {
              productName += value?.json?.map((v, i) => {
                return `${v.title} ${
                  v?.type == 2
                    ? v?.input_value?.label ?? ""
                    : v?.input_value ?? ""
                } `;
              });
            }
            return (
              <tr>
                <td>{value?.product?.value}</td>
                <td>{productName ?? "--"}</td>
                <td>{addCommas(value?.count)}</td>
                <td>عدد</td>
                <td>{addCommas(value?.price)}</td>
                <td>{addCommas(value?.price * value?.count)}</td>
                <td>{addCommas(value?.discount)}</td>
                <td>
                  {addCommas(
                    (value?.price - value?.discount) * value?.count > 0
                      ? (value?.price - value?.discount) * value?.count
                      : 0
                  )}
                </td>
                <td>
                  {addCommas(
                    calculateTax(
                      value?.price,
                      value?.count,
                      value?.discount,
                      dataFactor?.tax
                    )
                  )}
                </td>
                <td>
                  {addCommas(
                    calculateTotalPricePerProduct(
                      value?.price,
                      value?.count,
                      value?.discount,
                      dataFactor?.tax
                    )
                  )}
                </td>
              </tr>
            );
          })}

          <tr>
            <td colSpan={2}>جمع کل</td>

            <td>{addCommas(pricesData?.totalCount ?? 0)}</td>
            <td></td>

            <td></td>
            <td>{addCommas(pricesData?.totalPriceProducts)}</td>
            <td>{addCommas(pricesData?.totalDiscountProducts)}</td>
            <td>{addCommas(pricesData?.totalPriceProductsAfterDiscount)}</td>
            <td>{addCommas(pricesData?.totalTaxes)}</td>
            <td>{addCommas(pricesData?.totalPriceOrder)}</td>
          </tr>
          <tr>
            <td colSpan={4}>
              <div className="d-flex align-items-center">
                مالیات و عوارض:
                <span style={{ width: 50 }} className="mx-1">
                  <CustomInput
                    inputSize="sm"
                    inputValue={dataFactor?.tax}
                    activate={print ? "readOnly" : "active"}
                    plaintext={print}
                    onChangeFunc={(e) => {
                      dispatch({
                        type: ACTIONS.CHANGEPUBLIC,
                        payload: { tax: e.target.value },
                      });
                    }}
                    inputContainer="text-center"
                  />
                </span>
                درصد
              </div>
            </td>
            <td colSpan={6}>
              <div className="d-flex">
                <span className="ms-2">تخفیف</span>
                <span className="ms-auto me-5">
                  جمع فاکتور با احتساب:
                  {addCommas(pricesData?.totalPriceOrder ?? 0)}
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={4} style={{ textAlign: "start" }}>
              {print && <>توضیحات سفارش: {dataFactor?.description}</>}
            </td>
            <td colSpan={6} style={{ textAlign: "start" }}>
              جمع فاکتور با احتساب تخفیف:{" "}
              {numberToWords(pricesData?.totalPriceOrder?.toString() ?? 0)}{" "}
              تومان
            </td>
          </tr>
          <tr>
            <td colSpan={4} style={{ textAlign: "start" }}>
              توضیحات: شماره حساب شرکت صدرا بی‌بافت صنعت گرگان <br />{" "}
              01147372111004
              <br />
              IR390170000000114372111004
              <br />
              شماره کارت 6037997599275220
            </td>
            <td colSpan={6} style={{ textAlign: "start" }}>
              {print ? (
                <div className="d-flex  justify-content-between">
                  <div>مهر و امضا فروشنده:</div>
                  <div className="me-5">مهر و امضا خریدار:</div>
                </div>
              ) : (
                <></>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
